import { IApiResponse, ISearchResponse } from '../../../common/models/common';
import request from '../../../utils/request';
import {
  ISearchSlim360O365UserAiInteractions,
  ISlim360O365UserAiInteractions,
} from './o365UserAiInteractions.model';

class Slim360O365UserAiInteractionsService {
  ENDPOINT = '/slim360-o365-user-ai-interactions';

  public async searchSlim360O365UserAiInteractions(
    searchParams?: ISearchSlim360O365UserAiInteractions
  ): Promise<IApiResponse<ISearchResponse<ISlim360O365UserAiInteractions>>> {
    const url = `${this.ENDPOINT}/search`;
    return request({ url, method: 'POST', data: searchParams }).then((res) => {
      return res.data;
    });
  }

  public async getSlim360O365UserAiInteractionsById(id: number): Promise<any> {
    const url = `${this.ENDPOINT}/${id}`;
    return request({ url, method: 'GET' }).then((res) => {
      return res.data;
    });
  }

  public async saveSlim360O365UserAiInteractions(
    data: ISlim360O365UserAiInteractions
  ): Promise<any> {
    const { id, ...restData } = data;
    if (id > 0) {
      const url = `${this.ENDPOINT}/${id}`;
      return request({ url, method: 'PUT', data: restData }).then((res) => {
        return res.data;
      });
    } else {
      const url = `${this.ENDPOINT}`;
      return request({ url, method: 'POST', data: restData }).then((res) => {
        return res.data;
      });
    }
  }

  public async deleteSlim360O365UserAiInteractions(id: number): Promise<any> {
    const url = `${this.ENDPOINT}/${id}`;
    return request({ url, method: 'DELETE' }).then((res) => {
      return res.data;
    });
  }

  public async exportExcelFile(searchParams?: ISearchSlim360O365UserAiInteractions): Promise<any> {
    const url = `back-ground-processes/export-excel`;
    return request({
      url,
      method: 'POST',
      data: searchParams,
    }).then((res) => {
      return res;
    });
  }
}
export default new Slim360O365UserAiInteractionsService();
